import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table18 = ({ masoliatKhas, setMasoliatKhas, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)
  const [data, setData] = useState([])
  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.masoliatKhas;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 4, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 8, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 12, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 16, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 20, isSelected: masouliat.value == 4 },

      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setMasoliatKhas(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "masoliatKhas": selectedItem }))
    }
  }, [reload])

  return (
    <div>
      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          در صورت خطا یا اشتباه
          متصدی این شغل،
          عواقب یا زیان آنها
          متوجه شاغل می شود
        </Column>
        <Column paddingY={30}>
          دارای مسئولیت هایی در
          ارتباط با نگهداری
          اطلاعات محرمانه بوده و
          در صورت خطا یا اشتباه
          عواقب و زیان آن علاوه
          بر شاغل متوجه واحد می
          شود.
        </Column>
        <Column paddingY={30}>
          دارای مسئولیت‌هایی
          هستند که در صورت
          خطا یا اشتباه، عواقب
          و زیان آنها علاوه بر
          شاغل و واحد متوجه
          مدیریت نیز می شود.
        </Column>
        <Column paddingY={30}>
          دارای مسئولیت‌هایی
          هستند که در صورت
          خطا یا اشتباه، عواقب
          و زیان آن‌ها، علاوه بر
          شاغل، واحد و
          مدیریت، متوجه
          معاونت نیز می شود.
        </Column>
        <Column paddingY={30}>
          خطا و اشتباه در آن‌ها،
          دارای مسئولیتهای
          برون سازمانی و درون
          سازمانی است.
        </Column>
      </Row>
      <Row>
        <Column isActive={masoliatKhas == 4}>4</Column>
        <Column isActive={masoliatKhas == 8}>8</Column>
        <Column isActive={masoliatKhas == 12}>12</Column>
        <Column isActive={masoliatKhas == 16}>16</Column>
        <Column isActive={masoliatKhas == 20}>20</Column>
      </Row>
    </div>
  );
};

export default Table18;
